import script from "./HospitalProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalProfile.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalProfile.vue?vue&type=style&index=0&id=6a39d01e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a39d01e"]])

export default __exports__